import React, { useEffect, useState } from "react";
import Header from "./Header";
import { Link, useParams } from "react-router-dom";

const Dashboard = () => {
  const [sources, setSources] = useState([]);
  const { page } = useParams();

  const itemsPerPage = 5;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/course/coursedetails`
        );
        const data = await response.json();
        setSources(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const currentPage = page ? parseInt(page) : 1;
  const totalPages = Math.ceil(sources.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = sources.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div style={{ padding: "20px" }}>
      <Header />
      <h2>Dashboard</h2>
      <div style={{ marginBottom: "20px", display: "flex", gap: "15px" }}>
        <Link to="/admin/add-category">Add Category</Link>
        <Link to="/admin/add-course">Add Course</Link>
        <Link to="/admin/add-subject">Add Subject</Link>
        <Link to="/admin/add-topic">Add Topic</Link>
      </div>

      {/* TABLE */}
      {sources.length > 0 ? (
        <>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Category</th>
                <th style={thStyle}>Course</th>
                <th style={thStyle}>Subject</th>
                <th style={thStyle}>Topic</th>
                <th style={thStyle}>URL</th>
                <th style={thStyle}>Price</th>
              </tr>
            </thead>

            <tbody>
              {currentItems.map((item, index) => (
                <tr key={index}>
                  <td style={tdStyle}>{item.category_name}</td>
                  <td style={tdStyle}>{item.course_name}</td>
                  <td style={tdStyle}>{item.subject_name}</td>
                  <td style={tdStyle}>{item.topic_title}</td>
                  <td style={tdStyle}>{item.topic_url}</td>
                  <td style={tdStyle}>{item.price}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAGINATION FIXED — INSIDE RETURN BLOCK */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(
              (num) => (
                <Link
                  key={num}
                  to={`/dashboard/${num}`}
                  style={{
                    margin: "0 10px",
                    padding: "8px 12px",
                    border: "1px solid #2873b9",
                    borderRadius: "5px",
                    textDecoration: "none",
                    backgroundColor:
                      num === currentPage ? "#2873b9" : "transparent",
                    color: num === currentPage ? "white" : "#2873b9",
                  }}
                >
                  {num}
                </Link>
              )
            )}
          </div>
        </>
      ) : (
        <p>No courses found.</p>
      )}
    </div>
  );
};

const thStyle = {
  padding: "10px",
  border: "1px solid #2873b9",
  backgroundColor: "#eef7ff",
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #2873b9",
};

export default Dashboard;
